<report-grid-wrapper #gridWrapper [header]="header" [headerTag]="'h4'" [accountId]="accountId" [type]="GridType.SESSIONS">

	<vb-ui-infinite-scroll-grid [ngClass]="styles.grid" [context]="gridWrapper.gridProperties.context" [defaultColDef]="gridWrapper.gridProperties.defaultColDef" [gridOptions]="gridWrapper.gridProperties.options" [columnDefs]="columnDefs" [getRows]="AnalyticsService.getRows" [columnPickerEnabled]="true" [dataFetchContext]="AnalyticsService.dataFetchContext$ | async" [pageSize]="pageSize">

		<!--Column Picker Groups-->
		<vb-ui-column-picker-group [headerName]="'Video' | translate" [id]="ViewsColumnPickerGroup.VIDEO" [isExpanded]="true">
		</vb-ui-column-picker-group>

		<vb-ui-column-picker-group [headerName]="'User' | translate" [id]="ViewsColumnPickerGroup.USER" [isExpanded]="true">
		</vb-ui-column-picker-group>

		<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_Session' | translate" [id]="ViewsColumnPickerGroup.SESSION" [isExpanded]="true">
		</vb-ui-column-picker-group>

		<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_System' | translate" [id]="ViewsColumnPickerGroup.SYSTEM" [isExpanded]="true">
		</vb-ui-column-picker-group>

		<vb-ui-column-picker-group [headerName]="'Reports_Column_Group_Metrics' | translate" [id]="ViewsColumnPickerGroup.METRICS" [isExpanded]="true" [disableColumnEntrySort]="true">
		</vb-ui-column-picker-group>
	</vb-ui-infinite-scroll-grid>

</report-grid-wrapper>
